import React from 'react'
import { SvgIcon } from '@mui/material'

export const RahkarWappIcon = props => (
  <SvgIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      width="21"
      height="20"
      x="2"
      y="2"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path
        fill="#6264A7"
        d="M5.555 19.031a.586.586 0 1 0 0-1.171.586.586 0 0 0 0 1.171Z"
      />
      <path
        fill="#6264A7"
        d="M2.586 22h8.828v-9.414H2v8.828a.586.586 0 0 0 .586.586Zm2.969-5.314c.2.002.398.038.586.108v-1.866a.586.586 0 0 1 .85-.524l2.344 1.172a.587.587 0 0 1-.525 1.05l-1.496-.75v2.568a1.758 1.758 0 1 1-1.76-1.758ZM6.14 7.977l1.874-1.25-1.873-1.248v2.498Z"
      />
      <path
        fill="#6264A7"
        d="M11.414 2H2.586A.586.586 0 0 0 2 2.586v8.828h9.414V2ZM9.396 7.214 5.879 9.558a.586.586 0 0 1-.91-.488V4.383a.586.586 0 0 1 .91-.487l3.516 2.343a.586.586 0 0 1 0 .976v-.001ZM12.586 17.617l1.969-1.93a.586.586 0 0 1 .828 0l.758.758 1.93-1.93a.586.586 0 0 1 .828 0l3.1 3.1v-5.03h-9.413v5.032Z"
      />
      <path
        fill="#6264A7"
        d="m16.969 17.273.757.757a.585.585 0 1 1-.828.829l-1.93-1.93-2.382 2.344V22h8.828a.584.584 0 0 0 .586-.586v-2.14l-3.516-3.515-1.515 1.515ZM15.555 6.14h1.172v1.173h-1.172V6.14ZM17.898 7.538l1.172.586V5.332l-1.172.586v1.62Z"
      />
      <path
        fill="#6264A7"
        d="M21.829 2h-8.828v9.414h9.414V2.586A.587.587 0 0 0 21.829 2Zm-1.172 7.07a.586.586 0 0 1-.85.524l-2.22-1.11h-2.205a.585.585 0 0 1-.586-.585V5.553a.584.584 0 0 1 .586-.586h2.205l2.22-1.11a.586.586 0 0 1 .85.525V9.07Z"
      />
    </mask>
    <g mask="url(#a)">
      <path fill="url(#b)" d="M2 2h20v20H2z" />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1="12"
        x2="12"
        y1="2"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
